export default __webpack_public_path__ + "static/media/WM_logo_color.0de79271.svg";